//dependencias
import React, { Component } from 'react';

//componentes
import CanjeAction from './canje'

class Index extends Component {

    render(){
        return(
            <div>
                <CanjeAction />
            </div>
        );
    }

}
export default Index;